import { $authHost } from 'app/configs/axiosConfig';
import {
  AdminFilters,
  FilteredLeads,
  FilteredResubmits,
  GetZohoLeadOutput,
  ILead,
  ILeadFilteringOptions,
  ILeads,
  ILeadsItem,
  IResubmitRequest,
  IsActiveResponse,
  UpdateLeadRequest,
} from '../types';

export const getLeadsAll = (params: ILeadFilteringOptions) => {
  return $authHost.get<ILeads>('/leads', {
    params,
    paramsSerializer: (params) => {
      let result = '';
      Object.keys(params).forEach((key) => {
        if (params[key]) result += `${key}=${encodeURIComponent(params[key])}&`;
      });
      return result.substring(0, result.length - 1);
    },
  });
};

export const postLeadResubmit = (data: IResubmitRequest) => {
  return $authHost.post('/lead-resubmits', data);
};
export const deleteLeadResubmit = (cancelToken: string) => {
  return $authHost.delete<ILeadsItem>('/lead-resubmits', { data: { cancelToken } });
};
export const adminDeleteLeadResubmit = (requestId: number) => {
  return $authHost.delete<ILeadsItem>(`/lead-resubmits/${requestId}`);
};
export const updateLead = (leadId: number, body: UpdateLeadRequest) => {
  return $authHost.patch(`/leads/${leadId}`, body);
};

export const updateLeadApprovedStatus = (leadId: number, isApproved: boolean) => {
  return $authHost.patch(`/leads/${leadId}/approved-status`, {
    merchant: { isApproved },
  });
};

export const deleteLead = (leadId: number) => {
  return $authHost.delete(`/leads/${leadId}`);
};

export const getLeadById = (id: number) => {
  return $authHost.get<ILead>(`/leads/${id}`);
};

export const getFilteredLeads = (filters: AdminFilters) => {
  if (filters.where) {
    const where = filters.where as any;
    if (where.OR && Array.isArray(where.OR)) {
      where.OR = where.OR.map(processWhereCondition);
    }
    if (where.AND && Array.isArray(where.AND)) {
      where.AND = where.AND.map(processWhereCondition);
    }
  }
  return $authHost.post<FilteredLeads>(`/leads/filter`, filters);
};

export const getFilteredResubmits = (filters: AdminFilters) => {
  if (filters.where) {
    const where = filters.where as any;
    if (where.OR && Array.isArray(where.OR)) {
      where.OR = where.OR.map(processWhereCondition);
    }
    if (where.AND && Array.isArray(where.AND)) {
      where.AND = where.AND.map(processWhereCondition);
    }
  }
  return $authHost.post<FilteredResubmits>(`/lead-resubmits/filter`, filters);
};

const processWhereCondition = (condition: any): any => {
  if (!condition || typeof condition !== 'object') return condition;

  const processedCondition = { ...condition };

  Object.keys(processedCondition).forEach((key) => {
    const value = processedCondition[key];

    if (value && typeof value === 'object' && !Array.isArray(value)) {
      if (
        typeof value.contains === 'string' ||
        typeof value.equals === 'string' ||
        typeof value.startsWith === 'string' ||
        typeof value.endsWith === 'string'
      ) {
        value.mode = 'insensitive';

        if (value.contains) value.contains = value.contains.trim().replace(/\s+/g, ' ');
        if (value.equals) value.equals = value.equals.trim().replace(/\s+/g, ' ');
        if (value.startsWith) value.startsWith = value.startsWith.trim().replace(/\s+/g, ' ');
        if (value.endsWith) value.endsWith = value.endsWith.trim().replace(/\s+/g, ' ');
      } else {
        processedCondition[key] = processWhereCondition(value);
      }
    }
  });

  return processedCondition;
};

export const getCurrentZohoLead = () => {
  return $authHost.get<GetZohoLeadOutput>(`/leads/zoho`);
};

export const aiRecheck = (merchantId: number) => {
  return $authHost.post(`/leads/ai-recheck/`, {
    merchantId,
  });
};

export const hasActiveResubmit = () => {
  return $authHost.get<IsActiveResponse>(`/lead-resubmits/has-active`);
};

export const exportLeads = (where: object) => {
  return $authHost.post<{ data: string }>('/leads/export-v2', { where });
};
